import { getNestedProperty } from '@opallabs/lambda'
import {
  AssetReferenceCollection,
  AssetReference,
  State,
  StateKeys,
} from '../../../../types'

export const getAssetReferenceById: (
  state: State,
  id: string
) => AssetReference | undefined = (state, id) => {
  const assetReferences = getNestedProperty<AssetReferenceCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.asset_reference
  )
  if (assetReferences !== undefined) {
    return assetReferences[id]
  }
  return undefined
}

export const getAssetReferences: (
  state: State
) => AssetReferenceCollection | undefined = (state) =>
  getNestedProperty<AssetReferenceCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.asset_reference
  )
